import { Language } from "@app/core/user/domain/language";

const KEY_CATALAN = "ca";
const KEY_SPANISH = "es";
const KEY_ENGLISH = "en";
const KEY_FRENCH = "fr";
const KEY_GERMAN = "de";
const KEY_ITALIAN = "it";
const KEY_NETHERLANDS = "nl";
const KEY_PORTUGUESE = "pt";
const KEY_RUSSIAN = "ru";
const KEY_HEBREW = "he";
const KEY_ARABIC = "ar";

export function languageToString(language: Language) {
  switch (language) {
    case Language.CATALAN:
      return KEY_CATALAN;
    case Language.SPANISH:
      return KEY_SPANISH;
    case Language.ENGLISH:
      return KEY_ENGLISH;
    case Language.FRENCH:
      return KEY_FRENCH;
    case Language.GERMAN:
      return KEY_GERMAN;
    case Language.ITALIAN:
      return KEY_ITALIAN;
    case Language.NETHERLANDS:
      return KEY_NETHERLANDS;
    case Language.PORTUGUESE:
      return KEY_PORTUGUESE;
    case Language.RUSSIAN:
      return KEY_RUSSIAN;
    case Language.HEBREW:
      return KEY_HEBREW;
    case Language.ARABIC:
      return KEY_ARABIC;
  }
}
